import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';

@Component({
  selector: 'app-content-empty',
  templateUrl: './content-empty.component.html',
  styleUrls: ['./content-empty.component.scss']
})
export class ContentEmptyComponent implements OnInit {
  @Input() contentEmpty: string | undefined;
  @Input() padding =  false;
  constructor() { }

  ngOnInit(): void {
  }
}
